import { render, staticRenderFns } from "./CodesConfigurations.vue?vue&type=template&id=63da307b&scoped=true"
import script from "./CodesConfigurations.vue?vue&type=script&lang=js"
export * from "./CodesConfigurations.vue?vue&type=script&lang=js"
import style0 from "./CodesConfigurations.vue?vue&type=style&index=0&id=63da307b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63da307b",
  null
  
)

export default component.exports